import { inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpService } from 'src/app/shared/services/http.service';
import { Entidades, Foto } from '../components/card-entidades-foto/card-entidades-foto.interface';

@Injectable({
    providedIn: 'root',
})
export class FotoService {
    private readonly httpService = inject(HttpService);

    private readonly repositorio: string = 'v1/fotos';

    public _fotoExcluida = new Subject<void>();
    public _fotoAtualizada = new Subject<void>();

    /**
     * Retorna os dados da foto de uma entidade específica.
     *
     * @param entidadeID - O identificador único da entidade.
     * @param entidade - O tipo da entidade (por padrão, 'aluno').
     * @returns Um Observable contendo os dados da foto da entidade.
     */
    get(entidadeID: number, entidade: Entidades = 'aluno'): Observable<Foto> {
        return this.httpService.get<Foto>(
            this.repositorio + '/' + entidade + '/' + entidadeID + '/force',
        );
    }

    /**
     * Exclui a foto de uma entidade específica.
     *
     * @param entidadeID - O identificador único da entidade.
     * @param entidade - O tipo da entidade (por padrão, 'aluno').
     * @returns Um Observable indicando o resultado da operação de exclusão.
     */
    delete(entidadeID: number, entidade: Entidades = 'aluno'): Observable<any> {
        return this.httpService.delete<any>(
            this.repositorio + '/' + entidade + '/' + entidadeID,
            // this.httpOptions
        );
    }

    /**
     * Armazena uma nova foto para uma entidade específica.
     *
     * @param entidadeID - O identificador único da entidade.
     * @param entidade - O tipo da entidade (por padrão, 'aluno').
     * @param imagemBase64 - A imagem em formato Base64 a ser armazenada.
     * @returns Um Observable indicando o resultado da operação de armazenamento.
     */
    store(entidadeID: number, entidade: Entidades = 'aluno', imagemBase64: any): Observable<any> {
        return this.httpService.post<any>(
            this.repositorio + '/' + entidade + '/' + entidadeID,
            { file: imagemBase64 },
            // this.httpOptions
        );
    }
}
